import { } from "jquery"
import { Facility, Asset } from "../api/model"
import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi } from "../api/api"
import { UiUtils, JqElm, CreateElmFunc } from "./ui"
import { splitIgnoreEmpty } from "../utils/string"
import { inspect } from "util"
import { AssetPageBase, AssetBasicDataProvider } from "./asset_page_base"

export abstract class AssetEditPageBase extends AssetPageBase {

    protected abstract rootContainerId: string

    constructor(
        assetApi: AssetApi,
        private assetCategoryApi: AssetCategoryApi,
        private facilityApi: FacilityApi,
        private assetAreaApi: AssetAreaApi,
    ) {
        super(assetApi, new AssetBasicDataProvider(assetCategoryApi, facilityApi, assetAreaApi))
    }

    protected validateItemData(itemElm: JqElm): boolean {
        const recordId = itemElm.data('id')
        let allValid: boolean = true
        let facilityEnable = false
        let facilityIdsElm: JqElm
        itemElm.find('input,select').each((_, elm) => {
            const jqElm = $(elm)
            const name = jqElm.prop('name')
            if (elm instanceof HTMLInputElement || elm instanceof HTMLSelectElement) {
                if (name == 'facilityEnable') {
                    facilityEnable = UiUtils.isChecked(jqElm)
                }
                if (name == 'facilityIds') {
                    facilityIdsElm = jqElm
                }
                //const isRo = console.log(jqElm.prop('readonly'))
                const valid: boolean = elm.checkValidity()
                console.log("%s:%s", name, valid)
                if (!valid) {
                    allValid = false
                    if (name.startsWith("type_")) {
                        jqElm.parents('.radio-list').addClass('error').find('.invalid-feedback').show()
                    } else {
                        jqElm.addClass('error')
                        jqElm.next('.invalid-feedback').show()
                    }
                } else {
                    if (name.startsWith("type_")) {
                        jqElm.parents('.radio-list').removeClass('error').find('.invalid-feedback').hide()
                    } else {
                        jqElm.removeClass('error')
                        jqElm.next('.invalid-feedback').hide()
                    }
                }
            }
        })
        if (facilityEnable) {
            if ((<string>facilityIdsElm.val()).length == 0) {
                allValid = false
                facilityIdsElm.next('.invalid-feedback').show()
            }
        } else {
            facilityIdsElm.next('.invalid-feedback').hide()
        }
        return allValid
    }

    listenNoteChange() {
        $(document).on('change', '[name=note]', e => {
            console.log("note change")
            const elm = $(e.target)
            const btnElm = elm.prev('[name=note_btn]')
            const val = <string>elm.val()
            if (val != null && val.length > 0) {
                btnElm.text('已編輯').addClass('btn_selected')
            } else {
                btnElm.text('編輯').removeClass('btn_selected')
            }
        })
    }

    static facilityIdsElmChanged(elm: JqElm, assetBasicDataProvider: AssetBasicDataProvider) {
        const btnElm = elm.prev('[name=facilityIds_btn]')
        const facilityIdStr = elm.val()
        const facilityIds = facilityIdStr != null ? splitIgnoreEmpty(elm.val().toString(), ',') : []
        let names = ''
        if (facilityIds.length != 0) {
            names = assetBasicDataProvider.facilities
                .filter(it => facilityIds.indexOf(it.id) != -1)
                .map(it => it.name)
                .join('、')
            btnElm
                .text(`已選擇(${facilityIds.length})`)
                .addClass('btn_selected')
        } else {
            btnElm
                .text("選擇")
                .removeClass('btn_selected')
        }
        btnElm
            .attr('data-original-title', names)
            .tooltip('fixTitle')
    }

    listenFacilityIdsChange() {
        $(document).on('change', '[name=facilityIds]', e => {
            console.log("Facility ids change")
            const elm = $(e.target)
            AssetEditPageBase.facilityIdsElmChanged(elm, this.assetBasicDataProvider)
        })
    }

    static fillAreaElmData(areaSelectElm: JqElm, assetBasicDataProvider: AssetBasicDataProvider) {
        UiUtils.cleanOptions(areaSelectElm)
        areaSelectElm.append(UiUtils.options("請選擇", ""))
        for (const area of assetBasicDataProvider.areas) {
            areaSelectElm.append(UiUtils.options(area.name, area.id.toString()))
        }
    }

    fillAreaElmData(areaSelectElm: JqElm) {
        AssetEditPageBase.fillAreaElmData(areaSelectElm, this.assetBasicDataProvider)
    }

    static appendOtherAreaOption(areaSelectElm: JqElm) {
        areaSelectElm.append(UiUtils.options("待分區", "-1"))
    }

    appendOtherAreaOption(areaSelectElm: JqElm) {
        AssetEditPageBase.appendOtherAreaOption(areaSelectElm)
    }

    static fillCategoryElmData(rootCatSelectElm: JqElm, subCatSelectElm: JqElm, assetBasicDataProvider: AssetBasicDataProvider) {
        UiUtils.cleanOptions(rootCatSelectElm)
        rootCatSelectElm.append(UiUtils.options("請選擇", ""))
        for (const root of assetBasicDataProvider.catRoots) {
            rootCatSelectElm.append(UiUtils.options(root.name, root.id.toString()))
        }
        rootCatSelectElm.change(e => {
            this.fillSubCategoryElmData(subCatSelectElm, Number($(e.target).val()), assetBasicDataProvider)
        })
        rootCatSelectElm.val("").change()
    }

    fillCategoryElmData(rootCatSelectElm: JqElm, subCatSelectElm: JqElm) {
        AssetEditPageBase.fillCategoryElmData(rootCatSelectElm, subCatSelectElm, this.assetBasicDataProvider)
    }

    static fillSubCategoryElmData(subCatSelectElm: JqElm, parentId: number, assetBasicDataProvider: AssetBasicDataProvider) {
        UiUtils.cleanOptions(subCatSelectElm)
        if (parentId == 0 || parentId == -1) {
            UiUtils.setReadOnly(subCatSelectElm)
        } else {
            UiUtils.setReadOnly(subCatSelectElm, false)
            const cats = assetBasicDataProvider.catParentMap.get(parentId)
            if (cats.length != 1) {
                subCatSelectElm.append(UiUtils.options("請選擇", ""))
            }
            cats.forEach(cat => {
                const name = cat.isDefaultSubCat ? "其他" : cat.name
                subCatSelectElm.append(UiUtils.options(name, cat.id.toString()))
            })
        }
    }

    fillSubCategoryElmData(subCatSelectElm: JqElm, parentId: number) {
        AssetEditPageBase.fillSubCategoryElmData(subCatSelectElm, parentId, this.assetBasicDataProvider)
    }

    listenTypeClick() {
        $(document).on("change", `#${this.rootContainerId} input[name^=type]`, e => {
            const el = $(e.target)
            const val = el.val()
            const id = el.data('id')
            const wrapEl = this.elmById(id, 'normal_type_opt_wrap')
            if (val == "fixed") {
                wrapEl.hide()
                UiUtils.setChecked(wrapEl.find('[name=guestLoanable]'), false)
                UiUtils.setChecked(wrapEl.find('[name=facilityEnable]'), false).change()
            } else {
                wrapEl.css('display', 'table')
            }
        })
    }

    static facilityEnableElmChanged(elm: JQuery<HTMLElement>) {
        const id = elm.data('id')
        const checked = UiUtils.isChecked(elm)
        if (!checked) {
            this.setFacilityIdsData(id, [])
        }
        UiUtils.setDisabled(UiUtils.elmById(id, null, 'facilityIds_btn'), !checked)
    }

    listenFacilityEnable() {
        $(document).on("change", `#${this.rootContainerId} [name=facilityEnable]`, e => {
            const elm = $(e.target)
            AssetEditPageBase.facilityEnableElmChanged(elm)
        })
    }

    static initFacilityModal() {
        const page = this
        const modal = $('#facility_modal')
        modal.on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget)
            var recordId = button.data('id')
            modal.data('id', recordId)
            $('.facility_item').each((_, el) => {
                $(el).removeClass('zSelected')
            })
            const facilityIds = page.getFacilityIdsData(recordId)
            for (const fid of facilityIds) {
                $(`.facility_item[data-id="${fid}"]`).addClass('zSelected')
            }
        })
        $('#facility_modal_confirm').click(() => {
            const recordId = modal.data('id')
            const facilityIds: Array<string> = []
            $('.facility_item').each((_, el) => {
                const $el = $(el)
                if ($el.hasClass("zSelected")) {
                    facilityIds.push($el.data('id'))
                }
            })
            this.setFacilityIdsData(recordId, facilityIds)
        })
    }

    initFacilityModal() {
        AssetEditPageBase.initFacilityModal()
    }

    static initFacilityElms(assetBasicDataProvider: AssetBasicDataProvider) {
        //Append facility elms
        const wrap = $('.facility_item_wrap')
        for (const f of assetBasicDataProvider.facilities) {
            wrap.append($(`<button type="button" class="facility_item btn btn-default zInput" data-id="${f.id}">${f.name}</button>`))
        }
        //Set click event
        $('.facility_item').click(e => {
            const btn = $(e.target)
            btn.toggleClass('zSelected')
        })
    }

    //TODO - migrated
    initFacilityElms() {
        AssetEditPageBase.initFacilityElms(this.assetBasicDataProvider)
    }

    protected fillEditAssetData(assets: Array<Asset>, createElmFunc: CreateElmFunc, appendUndefinedArea?: boolean): Array<JqElm> {
        const excludNames = ["categoryId", "categoryRootId", "areaId", "guestLoanable"]
        return assets.map(asset => {
            console.log("Fill asset item:%s", inspect(asset))
            const elm = createElmFunc(asset.id != 0 ? asset.id.toString() : null)
            const id = elm.data('id')
            elm.find('input, select').toArray().map($).forEach(elm => {
                const name: string = elm.prop('name').toString()
                if (!name.startsWith('type_') && !excludNames.includes(name)) {
                    let val = (asset as any)[name]
                    if (elm[0] instanceof HTMLSelectElement) {
                        const validValues = UiUtils.getOptionValues(elm)
                        if (validValues.indexOf(val) == -1) {
                            console.log("Not in options:%s", val)
                            val = ''
                        }
                    }
                    elm.val(val).change()
                }
            })
            if (asset.guestLoanable) {
                UiUtils.setChecked(this.elmById(id, null, "guestLoanable")).change()
            }
            if (asset.loan > 0) {
                this.elmById(id, null, 'quantity').prop('min', asset.loan)
                this.elmById(id, 'min_quantity').text(asset.loan)
            }
            console.log("cat:%s", asset.categoryId)
            if (asset.categoryId != 0) {
                const cat = this.assetBasicDataProvider.catMap[asset.categoryId]
                if (cat != null) {
                    const rootCat = this.assetBasicDataProvider.catMap[cat.parentId]
                    if (rootCat != null) {
                        this.elmById(id, null, "categoryRootId").val(rootCat.id).change()
                        this.elmById(id, null, "categoryId").val(cat.id).change()
                    }
                }
            }
            const areaIdElm = this.elmById(id, null, "areaId")
            if (asset.areaId != null && this.assetBasicDataProvider.areaMap[asset.areaId]) {
                areaIdElm.val(asset.areaId).change()
            } else {
                if (appendUndefinedArea) {
                    this.appendOtherAreaOption(areaIdElm)
                    areaIdElm.val("-1").change()
                }
            }
            const typeElm = elm.find(`#type_${asset.type}_${id}`)
            UiUtils.setChecked(typeElm).change()
            if (asset.facilityIds != null) {
                UiUtils.setChecked(elm.find(`[name=facilityEnable]`)).change()
            }
            return elm
        })
    }


    private static getFacilityIdsData(recordId: string): Array<string> {
        const facilityIdsElm = UiUtils.elmById(recordId, null, 'facilityIds')
        const facilityIds = splitIgnoreEmpty(facilityIdsElm.val().toString(), ',')
        return facilityIds
    }

    static setFacilityIdsData(recordId: string, data: Array<string>) {
        const facilityIdsElm = UiUtils.elmById(recordId, null, 'facilityIds')
        facilityIdsElm.val(data.join(',')).trigger('change')
    }

    protected setFacilityIdsData(recordId: string, data: Array<string>) {
        AssetEditPageBase.setFacilityIdsData.apply(AssetEditPageBase, arguments)
    }

    protected initNoteEditModal() {
        const page = this
        const modal = $('#note_modal')
        const noteArea = $('[name="note_area"]')
        modal.on('show.bs.modal', function (event) {
            const button = $(event.relatedTarget)
            const recordId = button.data('id')
            modal.data('id', recordId)
            noteArea.val(page.elmById(recordId, null, 'note').val())
        })
        $('#note_modal_confirm').click(() => {
            const recordId = modal.data('id')
            const noteElm = page.elmById(recordId, null, 'note')
            noteElm.val(noteArea.val()).trigger('change')
        })
    }
}